"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_TYPE = exports.DAYS_OF_WEEK = void 0;
const types_1 = require("@vamstar/fox-api-common/esm/saved-search/types");
exports.DAYS_OF_WEEK = [
    types_1.DayOfWeek.MONDAY,
    types_1.DayOfWeek.TUESDAY,
    types_1.DayOfWeek.WEDNESDAY,
    types_1.DayOfWeek.THURSDAY,
    types_1.DayOfWeek.FRIDAY,
    types_1.DayOfWeek.SATURDAY,
    types_1.DayOfWeek.SUNDAY,
];
var CLIENT_TYPE;
(function (CLIENT_TYPE) {
    CLIENT_TYPE[CLIENT_TYPE["FOX_BACKEND"] = 0] = "FOX_BACKEND";
    CLIENT_TYPE[CLIENT_TYPE["SCOUT_BACKEND"] = 1] = "SCOUT_BACKEND";
})(CLIENT_TYPE = exports.CLIENT_TYPE || (exports.CLIENT_TYPE = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2ludGVyZmFjZXMvY29tbW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUdILDBFQUEyRTtBQUk5RCxRQUFBLFlBQVksR0FBRztJQUMxQixpQkFBUyxDQUFDLE1BQU07SUFDaEIsaUJBQVMsQ0FBQyxPQUFPO0lBQ2pCLGlCQUFTLENBQUMsU0FBUztJQUNuQixpQkFBUyxDQUFDLFFBQVE7SUFDbEIsaUJBQVMsQ0FBQyxNQUFNO0lBQ2hCLGlCQUFTLENBQUMsUUFBUTtJQUNsQixpQkFBUyxDQUFDLE1BQU07Q0FDakIsQ0FBQztBQUVGLElBQVksV0FHWDtBQUhELFdBQVksV0FBVztJQUNyQiwyREFBZSxDQUFBO0lBQ2YsK0RBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUhXLFdBQVcsR0FBWCxtQkFBVyxLQUFYLG1CQUFXLFFBR3RCIn0=